import React, { useState, useEffect } from 'react';
import { ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import InputText from '../../../../../commonModules/interface/form-input-inline';
import LinkSpending from '../../../Repayment/LinkSpending';
import Currency from '../../../../../commonModules/Currency';
import { remainingAmount, matchTotal } from '../../../../../../../../jsx/utils/factId5000';

const LinkPurchasePopUp = (props) => {
    const [state, setState] = useState({
        parts: {},
        max: {},
        total: {},
        errors: {},
    });

    useEffect(() => {
        const { PURCHASES, checkedPayments, transfer } = props;
        const parts = {};
        const max = {};
        const total = {};
        console.log('====================================');
        console.log({checkedPayments, PURCHASES, transfer});
        console.log('====================================');
        checkedPayments.forEach((ID) => {
            // Le transfer passé en props prime sur la liste du store : c'est celui qu'affiche
            // l'écran de détail, et il est à jour après un pointage.
            const operation = (transfer && transfer.id === ID) ? transfer : (PURCHASES && PURCHASES[ID]);
            if (!operation) return;

            // Le montant proposé, et la borne haute, sont le reste à pointer — pas le coût de
            // l'achat. La branche transfer lisait purchase_total_available, un nom hérité que ces
            // documents ne portent pas : elle retombait sur prix_revient et annonçait « Max »
            // au montant total, autorisant la saisie d'un montant que le back refuse ensuite.
            const remaining = remainingAmount(operation);
            const reference = matchTotal(operation);
            const available = remaining === null ? reference : remaining;

            parts[ID] = available;
            max[ID] = available;
            total[ID] = reference;
        });

        setState((prevState) => ({
            ...prevState,
            parts,
            max,
            total,
        }));

        props.handleChangeParts(parts);
    }, [props.PURCHASES, props.checkedPayments, props.transfer]);

    const handleChange = (e, ID) => {
        const { name, value } = e.target;
        const { parts } = state;

        setState((prevState) => ({
            ...prevState,
            parts: {
                ...parts,
                [ID]: parseFloat(value),
            },
        }));

        props.handleChangeParts({
            ...parts,
            [ID]: parseFloat(value),
        });
    };

    const rmPayment = (ID) => {
        const { parts } = state;
        const updatedParts = { ...parts };
        delete updatedParts[ID];

        setState((prevState) => ({
            ...prevState,
            parts: updatedParts,
        }));

        props.rmPayment(ID);
    };

    return (
        <LinkSpending 
            title="Pointer les achats" 
            handleChange={props.handleChange}
            spendingID={props.spendingID}
            handleSubmitLink={props.handleSubmitLink}
            totalPay={props.totalPay}
            handleClose={props.handleClose}
        >
            {(props.checkedPayments && Array.isArray(props.checkedPayments) ? props.checkedPayments : []).map((ID) => {
                // Utiliser le transfer si disponible, sinon utiliser PURCHASES
                const purchase = (props.transfer && props.transfer.id === ID) 
                    ? props.transfer 
                    : (props.PURCHASES && props.PURCHASES[ID]) 
                        ? props.PURCHASES[ID] 
                        : null;
                
                if (!purchase) return null;
                
                const shopName = props.SHOPS && props.SHOPS[purchase.shop_id] 
                    ? props.SHOPS[purchase.shop_id].name 
                    : 'Magasin inconnu';
                const date = purchase.creation_date || purchase.date || new Date();
                
                return (
                    <ListItem key={ID}>
                        <ListItemAvatar onClick={() => rmPayment(ID)} style={{ cursor: 'pointer' }}>
                            <CloseRounded color="error" />
                        </ListItemAvatar>
                        <ListItemText
                            primary={shopName}
                            secondary={new Date(date).toLocaleString('fr-FR')}
                        />
                        <ListItemSecondaryAction>
                            <InputText
                                required
                                label="Montant"
                                type="number"
                                name="amount"
                                value={state.parts[ID] || 0}
                                onChange={(e) => handleChange(e, ID)}
                                error={state.errors[ID]}
                                helperText={`Max: ${state.max[ID]} / ${state.total[ID]}`}
                                size="small"
                            />
                        </ListItemSecondaryAction>
                        <hr />
                    </ListItem>
                );
            })}
        </LinkSpending>
    );
};

export default LinkPurchasePopUp;
